import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from './auth.service';
import {take} from "rxjs/operators";
import {Router} from "@angular/router";
import {B2B_LAST_CLOSE_KEY, B2B_TAB_ID_KEY, B2B_TABS_KEY} from "../data-mock/data-mock";

@Injectable({
  providedIn: 'root',
})
export class TabSessionService {
  private readonly TABS_KEY = B2B_TABS_KEY;
  private readonly TAB_ID_KEY = B2B_TAB_ID_KEY;
  private readonly LAST_CLOSE_KEY = B2B_LAST_CLOSE_KEY;

  /**
   * Якщо вкладка відкрилась швидше ніж через 2 секунди
   * після закриття останньої вкладки, вважаємо це refresh.
   */
  private readonly REOPEN_GRACE_PERIOD = 3000;

  private tabId!: string;

  constructor(
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: object,
    private router: Router,
  ) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.tabId = this.getOrCreateTabId();
    const shouldLogout = this.checkLastClose();

    if (!shouldLogout) {
      this.registerTab();
      this.listenPageHide();
    }
  }

  private getOrCreateTabId(): string {
    let id = sessionStorage.getItem(this.TAB_ID_KEY);
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem(this.TAB_ID_KEY, id);
    }
    return id;
  }

  private getTabs(): Record<string, boolean> {
    try {
      return JSON.parse(
        localStorage.getItem(this.TABS_KEY) || '{}'
      );
    } catch {
      return {};
    }
  }

  private saveTabs(tabs: Record<string, boolean>): void {
    localStorage.setItem(
      this.TABS_KEY,
      JSON.stringify(tabs)
    );
  }

  private registerTab(): void {
    const tabs = this.getTabs();
    tabs[this.tabId] = true;
    this.saveTabs(tabs);
  }

  private unregisterTab(): number {
    const tabs = this.getTabs();
    delete tabs[this.tabId];
    this.saveTabs(tabs);

    return Object.keys(tabs).length;
  }

  private listenPageHide(): void {
    window.addEventListener('pagehide', () => {
      const activeTabs = this.unregisterTab();
      if (activeTabs === 0) {
        localStorage.setItem(
          this.LAST_CLOSE_KEY,
          String(Date.now())
        );
      }
    });
  }

  private checkLastClose(): boolean  {
    const lastClose = Number(
      localStorage.getItem(this.LAST_CLOSE_KEY)
    );
    if (!lastClose) {
      return false;
    }

    localStorage.removeItem(this.LAST_CLOSE_KEY);

    const diff = Date.now() - lastClose;
    // check if page was refreshed
    if (diff < this.REOPEN_GRACE_PERIOD) {
      console.log('diff < REOPEN_GRACE_PERIOD')
      return false;
    }
    console.log('lastClose diff>', lastClose);
    this.authService
      .logoutUser()
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.clearStorageForAutoLogOut();
          this.router.navigate(['/start']).then(() => {
            // if (isPlatformBrowser(this.platformId)) {
            //   location.reload();
            // }
          });
        },
        error: (err) => {
          console.error('Помилка logout:', err);
          this.clearStorageForAutoLogOut();
          this.router.navigate(['/start']).then(() => {
            if (isPlatformBrowser(this.platformId)) {
              location.reload();
            }
          });
        }
      });
    return true;
  }
  private clearStorageForAutoLogOut(): void {
    localStorage.removeItem(B2B_LAST_CLOSE_KEY);
  }
}
